import envVar from '../config/envVars';

type LinkType = 'reactAppEtherBaseUrl';

const getBaseUrl = (school: string, type: LinkType) => {
  let baseUrl = '';

  switch (type) {
    case 'reactAppEtherBaseUrl':
      baseUrl = envVar.REACT_APP_ETHER_BASE_URL || '';
      break;
  }

  const url = new URL(baseUrl);

  switch (school) {
    case 'BPIS':
      url.hostname = `bpis.${url.hostname}`;
      break;
    default:
      break;
  }

  const urlStr = url.toString();
  // Remove trailing slash unless it's the root
  return urlStr.endsWith('/') && urlStr.length > url.origin.length
    ? urlStr.slice(0, -1)
    : urlStr;
};

export default getBaseUrl;
